import { createSlice } from "@reduxjs/toolkit";
import { checkStudentsMassiveApSchool, saveStudentsMassiveApSchool } from "./async-thunks";
import { ResponseStatusEnum } from "@src/redux/seller-clients";

type dbValue = {
  value: number,
  label: string
}

type nullableDbValue = {
  value: number | null,
  label: string
}

type validatedStudent = {
  index: number,
  name: string,
  lastName: string,
  lastName2: string,
  birthDate: string,
  taxData: dbValue,
  group: nullableDbValue,
  sex: string | null,
  state: nullableDbValue,
  city: string | null,
  tutorEmail: string | null
}

const initialState: { status: ResponseStatusEnum; validatedStudents: validatedStudent[] } = {
  status: ResponseStatusEnum.idle,
  validatedStudents: []
};

export const clientsStudentsSlice = createSlice({
  name: "clientsStudents",
  initialState,
  reducers: {
    reset: (state) => {
      state.status = ResponseStatusEnum.idle;
      state.validatedStudents = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(checkStudentsMassiveApSchool.fulfilled, (state, action) => {
      state.status = ResponseStatusEnum.success;
      state.validatedStudents = action.payload;
    });
    builder.addCase(checkStudentsMassiveApSchool.pending, (state) => {
      state.status = ResponseStatusEnum.loading;
    });
    builder.addCase(checkStudentsMassiveApSchool.rejected, (state) => {
      state.status = ResponseStatusEnum.error;
    });
    builder.addCase(saveStudentsMassiveApSchool.fulfilled, (state) => {
      state.validatedStudents = [];
      state.status = ResponseStatusEnum.success;
    });
    builder.addCase(saveStudentsMassiveApSchool.pending, (state) => {
      state.status = ResponseStatusEnum.loading;
    });
    builder.addCase(saveStudentsMassiveApSchool.rejected, (state) => {
      state.status = ResponseStatusEnum.error;
    });
  }
});

export const clientsStudentsReducer = clientsStudentsSlice.reducer;
